<div class="modal-header">
    <span *ngIf="currentModule == '/products'" class="modal-header-title"> Интеграция c поставщиками</span>
    <span *ngIf="currentModule == '/settings'" class="modal-header-title"> Интеграция с торговой сетью </span>
</div>
<div class="modal-body">

    <form class="form" [formGroup]="form" autocomplete="off">

        <div class="row">

            <div *ngIf="currentModule == '/products'" class="col-12">
                <div class="form-group">
                    <div class="form-group">
                        <label class="filter-label" for="attribute_id_field"> Выберите поставщика:</label>
                        <ng-select id="attribute_id_field"
                         class="custom" 
                         clearAllText="{{ 'CLEAN' | translate }}"
                         notFoundText="{{ 'NO_DATA' | translate }}" 
                         bindLabel="name" 
                         bindValue="org_id"
                         formControlName="org_id"
                         [items]="providers" 
                         appendTo="body"
                         >
                            <!-- <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                <input id="item-{{index}}" type="checkbox"
                                    [checked]="item$.selected" />&nbsp;
                                <span>{{item.name}}</span>
                            </ng-template> -->
                        </ng-select>

                    </div>
                </div>
            </div>   

            <div *ngIf="currentModule == '/settings'" class="col-12">
                <div class="form-group">
                    <div class="form-group">
                        <label class="filter-label" for="attribute_id_field"> Выберите торговую сеть:</label>
                        <ng-select id="attribute_id_field"
                         class="custom" 
                         clearAllText="{{ 'CLEAN' | translate }}"
                         notFoundText="{{ 'NO_DATA' | translate }}" 
                         bindLabel="name" 
                         bindValue="org_id"
                         [multiple]="true"
                         [closeOnSelect]="false"
                         formControlName="org_id"
                         [items]="providers" 
                         appendTo="body"
                         >
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                <input id="item-{{index}}" type="checkbox"
                                    [checked]="item$.selected" />&nbsp;
                                <span>{{item.name}}</span>
                            </ng-template>
                        </ng-select>

                    </div>
                </div>
            </div>   

            <div class="col-12 table-block" *ngIf="currentModule == '/products'">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col" class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_all_providers"
                                        id="select_all_providers" [checked]="isAllCheckBoxChecked()"
                                        [indeterminate]="checkedButNotAllCheckBox()"
                                        (change)="checkAllCheckBox($event)">
                                    <label class="custom-control-label" for="select_all_providers"></label>
                                </div>
                            </th>
                            <th scope="col" class="photo">Фото</th>
                            <th scope="col" class="name">Наименование </th>
                            <th scope="col" class="barcode">Штрих-код </th>
                            <!-- <th scope="col">Артикул </th> -->
                        </tr>
                    </thead>
                    <tbody *ngIf="products && products.length > 0">
                        <tr *ngFor="let product of products; let i = index">
                            <td class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_providers_{{ i }}"
                                        id="select_providers_{{ i }}" [checked]="product.checked"
                                        (change)="selectedCheckBox(i, $event)">
                                    <label class="custom-control-label" for="select_providers_{{ i }}"></label>
                                </div>
                            </td>
                            <td class="photo">
                                
                                <div class="block-photo" *ngIf="product.file_small">

                                    <img src="{{ product.file_small }}"> 

                                    <!-- <div [ngClass]="{'gallertPerview': isGalleryOpen}">
                                        <ks-modal-gallery  [attr.hidden]="isGalleryOpen === true ? null : 'true'" 
                                        (close)="isGalleryOpen=false;" [id]="i" [modalImages]="product.file_content" [plainGalleryGrid]="plainGalleryGrid"></ks-modal-gallery>
                                    </div> -->
                                </div>
                               
                                <div class="block-no-photo" *ngIf="!product.file_small">
                                    <img src="/assets/images/no-image-available.png">
                                </div>
                            </td>
                            <td class="attr-fields" class="name">
                                {{product.name}}
                            </td>
                            <td class="attr-fields" class="barcode">
                                {{product.barcode}}
                            </td>
                            <!-- <td class="attr-fields">
                                {{product.article}}
                            </td> -->
                        </tr>
                    </tbody>

                    <tbody *ngIf="!products || products.length == 0">
                        <tr>
                            <td *ngIf="loading" class="data-loading" colspan="4">
                                <div class="spinner-bars">
                                    <div class="loadingio-spinner-bars-preLoder-inner">
                                        <div class="preLoder">
                                            <div></div><div></div><div></div><div></div>
                                        </div>
                                    </div>
                                    <div>{{ 'LOADING' | translate }}</div>
                                </div>
                            </td>
                            <td *ngIf="!loading" class="data-not-found" colspan="4">
                                <div>{{ 'DATA_NOT_FOUND' | translate }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            

        </div>

    </form>

</div>
<div class="modal-footer btn-box">
    <button *ngIf="currentModule == '/products'" type="button" class="btn btn-primary btn-sm" (click)="onIntegrationProducts()" [disabled]="form.invalid">{{ 'SAVE'| translate}}</button>
    <button *ngIf="currentModule == '/settings'" type="button" class="btn btn-primary btn-sm" (click)="onCreateIntegration()">{{ 'SAVE'| translate}}</button>
    <button *ngIf="currentModule == '/products'" type="button" class="btn btn-light btn-sm"   (click)="activeModal.dismiss(false)">{{ 'CLOSE' | translate}}</button>
</div>